'use es6';

import { UsageTracker } from 'analytics-tools-lib/lib/trackers';
let shouldReportSourceRetention = false;
export const appKeyToTrackingTool = appkey => {
  return appkey === 'engagement-emails' ? 'emails' : appkey;
};
export const activateSourceRetentionTracking = () => {
  shouldReportSourceRetention = true;
};
export const trackSourceRetention = () => {
  if (shouldReportSourceRetention) {
    shouldReportSourceRetention = false;
    UsageTracker.track('userRetained', {
      action: 'userRetained',
      tool: 'sources'
    });
  }
};